import { render, staticRenderFns } from "./IamSettings.vue?vue&type=template&id=2a330690&"
import script from "./IamSettings.vue?vue&type=script&lang=ts&"
export * from "./IamSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports